import styled from "styled-components";

export const Container = styled.div<{ $limitarALargura: boolean }>`
  margin-top: 2.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};

  /* a lib deixa a seta fixa na coluna ordenada; o 1º span é o título */
  .rdt_TableCol_Sortable > span:not(:first-child) {
    opacity: 0;
  }

  .rdt_TableCol_Sortable:hover > span:not(:first-child),
  .rdt_TableCol_Sortable:focus > span:not(:first-child) {
    opacity: 0.7;
  }

  /* o wrapper da lib é display: table e cresceria até caber o texto mais longo sem quebra */
  ${({ $limitarALargura }) =>
    $limitarALargura &&
    `
    .rdt_TableCol,
    .rdt_TableCell {
      contain: inline-size;
    }
  `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const TextoHeader = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 6px;
`;

export const HeaderContainerBotoes = styled.div`
  display: flex;
  gap: 8px;
`;

export const BotaoIcone = styled.div`
  button {
    width: 2.3rem;
    padding: 0;
  }
`;
